import { Typography } from '@mui/material'
import { useStyles } from '../DetailedOffer.styles'
import clsx from 'clsx'
import { isEmpty } from 'lodash'
import { DetailedOffer } from '../DetailedOffer'
import { dateAndTimeConversion } from '../../../../common/utils/dateAndTimeConversion'
import { useTimeZone } from '../../../../common/utils/hooks/useTimeZone'

interface CustomerTermSectionProps {
  offer: DetailedOffer
}

export const getAzureStartDateValue = (
  offer: DetailedOffer,
  azureStartDate: string
) => {
  if (offer?.variableStartDate === undefined) {
    return '-'
  } else if (offer?.variableStartDate) {
    return 'Accepted date'
  } else if (offer?.variableStartDate === false && offer?.offerStartDate) {
    return azureStartDate
  } else {
    return '-'
  }
}

export const CustomerTermSection = ({ offer }: CustomerTermSectionProps) => {
  const { classes } = useStyles()
  const { timeZone } = useTimeZone()
  const { modifiedDate: azureEndDate } = dateAndTimeConversion(
    offer?.offerExpirationDate ?? '',
    timeZone
  )

  const { modifiedDate: azureAcceptBy } = dateAndTimeConversion(
    offer?.acceptBy ?? '',
    timeZone
  )

  const { modifiedDate: azureStartDate } = dateAndTimeConversion(
    offer?.offerStartDate ?? '',
    timeZone
  )
  return (
    <div className={classes.box}>
      <div className={classes.row}>
        <div className={clsx(classes.cell, classes.installmentsTableCell)}>
          <Typography
            className={clsx(classes.heading, classes.eula)}
            data-testid="offer-start-label"
          >
            Start date
          </Typography>
          <Typography
            className={clsx(classes.dataText, classes.regularText)}
            data-testid="offer-start-date"
          >
            {getAzureStartDateValue(offer, azureStartDate)}
          </Typography>
        </div>
        <div className={clsx(classes.cell, classes.installmentsTableCell)}>
          <Typography
            className={clsx(classes.heading, classes.eula)}
            data-testid="offer-end-label"
          >
            End date
          </Typography>
          <Typography
            className={clsx(classes.dataText, classes.regularText)}
            data-testid="offer-end-date"
          >
            {isEmpty(offer?.offerExpirationDate) ? '-' : azureEndDate}
          </Typography>
        </div>
        <div className={clsx(classes.cell, classes.installmentsTableCell)}>
          <Typography
            className={clsx(classes.heading, classes.eula)}
            data-testid="offer-expiration-label"
          >
            Offer expiration date
          </Typography>
          <Typography
            className={clsx(classes.dataText, classes.regularText)}
            data-testid="offer-expiration-date"
          >
            {isEmpty(offer?.acceptBy) ? '-' : azureAcceptBy}
          </Typography>
        </div>
      </div>
    </div>
  )
}
